import EServiceEngineerActions from '@r1-frontend/service-engineer-visit/constants/actions';
import { TDay } from '@r1-frontend/service-engineer-visit/reducer/initialState';
import { IAction } from '@r1-frontend/service-engineer-visit/reducer/reducer';

const setSlots = (slots: Record<string, TDay>): IAction<EServiceEngineerActions.SET_SLOTS, { slots: Record<string, TDay> }> => ({
    type: EServiceEngineerActions.SET_SLOTS,
    payload: { slots },
});

export default setSlots;
